<template>
	<div>
		<div class="sections">
			<section>
				<ContactPurchase
					:conversation="message.conversation"
					:job-profile-id="message.jobProfile.id"
					:job-id="message.job.id"
					:pseudonym="message.pseudonym"
					type="accept"
					initiator="applicant"
					@purchase="onContacted"
				/>
			</section>
		</div>
	</div>
</template>

<script>
import ContactPurchase from "@/vue/communication/ContactPurchase";

export default {

	components: {
		ContactPurchase,
	},

	props: {
		message: {
			type: Object,
			required: true,
		},
	},

	methods: {
		onContacted ()
		{
			this.$emit('processed');
		},
	},
}
</script>
